export function selectGenerator(array){
  const heroes = array.sort((a,b) => a.localeCompare(b)).map(item => {
    return {value: item, label: item}
  })

  return [{ value: null, label: 'UNKNOWN'}, ...heroes]
}